import * as React from 'react';
import styled from 'styled-components';
import { lighten } from 'polished';

import Button from '../Shared/Button';
import t from './locales';
import { colors } from '../styles/variables';
import { getImage, getCountry } from '../utils/pathHelper';
import hotelIcon from './images/line_icon/hotel_40px_blue.svg';
import liftIcon from './images/line_icon/lift_40px_blue.svg';
import liftRentalIcon from './images/line_icon/lift_rental_40px_blue.svg';
import busIcon from './images/line_icon/bus_40px_blue.svg';
import insuranceIcon from './images/line_icon/insurance_40px_blue.svg';

const CartUpSellContainerView = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  margin: 24px 0;
  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const CartUpSellItemView = styled.a`
  display: block;
  padding: 8px;
  border-radius: 4px;
  text-decoration: none;
  color: ${colors.blue};
  border: 1px solid ${colors.blue};
  transition: 0.2s all ease-in-out;
  text-align: center;
  grid-column: span 1;
  p {
    margin: 4px 0;
    font-size: 12px;
  }
  i {
    margin-right: 4px;
  }
  img {
    width: 40px;
  }
  &:hover {
    color: ${colors.blue};
    border: 1px solid ${colors.blue};
    text-decoration: none;
    background-color: ${lighten(0.5, colors.blue)};
  }
`;

const CartUpSellInsuranceView = styled.div`
  display: block;
  padding: 8px;
  border-radius: 4px;
  text-decoration: none;
  color: ${colors.blue};
  border: 1px solid ${colors.blue};
  transition: 0.2s all ease-in-out;
  text-align: left;
  grid-column: span 2;
  p {
    margin: 4px 0;
    font-size: 12px;
  }
  img {
    width: 40px;
  }
`;

const FlexBox = styled.div`
  display: flex;
  align-items: center;
`;

const CartUpSell: React.FC<{}> = () => {
  // 台湾当局から違法性の指摘があったため、全リージョンで一時的に保険関連を非表示にする対応
  return null;

  function notReady(event: React.MouseEvent) {
    event.preventDefault();
    alert('Not ready yet. We are working hard on it!');
  }
  return getCountry() == 'jp' ? null : (
    <CartUpSellContainerView>
      {/*<CartUpSellItemView href="/snow/searches?yado_orderable=1">
        <p>{t.addAccommodation()}</p>
        <div>
          <i className="fas fa-plus" />
          <img src={getImage(hotelIcon)} />
        </div>
      </CartUpSellItemView>

      <CartUpSellItemView href="/snow/searches?orderable%5B%5D=type_lift">
        <p>{t.addLiftTicket()}</p>
        <div>
          <i className="fas fa-plus" />
          <img src={getImage(liftIcon)} />
        </div>
      </CartUpSellItemView>

      <CartUpSellItemView href="/snow/searches?orderable%5B%5D=type_rental">
        <p>{t.addLiftTicketAndRental()}</p>
        <div>
          <i className="fas fa-plus" />
          <img src={getImage(liftRentalIcon)} />
        </div>
      </CartUpSellItemView>

      <CartUpSellItemView href="#" onClick={notReady}>
        <p>{t.addTransport()}</p>
        <div>
          <i className="fas fa-plus" />
          <img src={getImage(busIcon)} />
        </div>
    </CartUpSellItemView>*/}

    {getCountry() != 'tw' && 
      <CartUpSellInsuranceView>
        <FlexBox style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <FlexBox>
            <div style={{ padding: 8 }}>
              <img src={getImage(insuranceIcon)} />
            </div>
            <div>
              <p style={{ fontWeight: 'bold' }}>{t.whatWillYouDoIfThisHappen()}</p>
              <p>{[t.youBecomeInjuredOrIll(),
                t.theStaffCanNotUnderstandYourLanguage(),
                t.yourPassportOrCreditCardIsLostStolen()].join('')}</p>
              <p>{t.youCanFeelRelievedWithJapanTravelInsurance()}</p>
            </div>
          </FlexBox>
          <div style={{ padding: 8 }}>
            <Button href='/snow/insurance/standard'>{t.addInsurance()}</Button>
          </div>
        </FlexBox>
      </CartUpSellInsuranceView>
    }

    </CartUpSellContainerView>
  );
}

export default CartUpSell;
